// extracted by mini-css-extract-plugin
module.exports = {"TableHeading__Cell":"TableHeading_TableHeading__Cell__2J7Wf"};